// extracted by mini-css-extract-plugin
export default {"container":"AppFooter_container__1KnYB","bold":"AppFooter_bold__BGia-","kiaiLogo":"AppFooter_kiaiLogo__5wJWc","divider":"AppFooter_divider__6bQLX"};